<template>
  <div class="shop-pagination" v-if="showPagination">
    <ul>
      <li>
        <button
          class="no-round-btn smooth"
          v-on:click="loadPage(1)"
        >
          <i class="arrow_carrot-2left"></i>
        </button>
      </li>
      <li>
        <button
          class="no-round-btn smooth"
          v-on:click="loadPage('prev')"
        >
          <i class="arrow_carrot-left"></i>
        </button>
      </li>
      <template v-if="notEnoughPages">
        <template v-for="n in totalPage">
          <li>
            <button
              :class="'no-round-btn smooth internal ' + (isCurrentPage(n) ? 'active' : '')"
              v-on:click="loadPage(n)"
              v-text="n"
            ></button>
          </li>
        </template>
      </template>
      <template v-else>
        <template v-for="n in windowSize">
          <li>
            <button
              :class="'no-round-btn smooth internal ' + (isCurrentPage(windowStart+n-1) ? 'active' : '')"
              v-on:click="loadPage(windowStart+n-1)"
              v-text="windowStart+n-1"
            ></button>
          </li>
        </template>
      </template>
      <li>
        <button
          class="no-round-btn smooth"
          v-on:click="loadPage('next')"
        >
          <i class="arrow_carrot-right"></i>
        </button>
      </li>
      <li>
        <button
          class="no-round-btn smooth"
          v-on:click="loadPage(totalPage)"
        >
          <i class="arrow_carrot-2right"></i>
        </button>
      </li>
    </ul>
  </div>
</template>

<script>
import PaginationMixin from 'vuetable-2/src/components/VuetablePaginationMixin.vue';
import PaginationInfoMixin from 'vuetable-2/src/components/VuetablePaginationInfoMixin.vue';

export default {
    mixins: [
        PaginationMixin,
        PaginationInfoMixin
    ],
    props: {
        showPagination: {
            type: Boolean,
            default: true
        }
    }
};
</script>
